import { render, staticRenderFns } from "./ClaimsDetail.vue?vue&type=template&id=46f3d589&scoped=true"
import script from "./ClaimsDetail.vue?vue&type=script&lang=js"
export * from "./ClaimsDetail.vue?vue&type=script&lang=js"
import style0 from "./ClaimsDetail.vue?vue&type=style&index=0&id=46f3d589&prod&scoped=true&lang=css"
import style1 from "./ClaimsDetail.vue?vue&type=style&index=1&id=46f3d589&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f3d589",
  null
  
)

export default component.exports